/* istanbul ignore file */
import { createRoute, useEntityUrl } from 'framework/routing';

const LEDGER_PATH = '/ledger';

export const getLedgerListUrl = () => LEDGER_PATH;

export const getLedgerRouterPath = () => `${LEDGER_PATH}/*`;

export const useLedgerRoute = () => createRoute({ listRoute: LEDGER_PATH });

export const useLedgerUrl = () =>
  useEntityUrl({
    baseLink: LEDGER_PATH,
  });
